import { Box } from '@primer/react';
import { useLiveCheckinDataContext } from '../live-checkin/useLiveCheckInDataContext';
import LiveCheckInHocSinh from './LiveCheckInHocSinh';

const LiveCheckInHocSinhList = () => {
    const { filteredData } = useLiveCheckinDataContext();

    return (
        <Box sx={{ display: "grid" }}>
            <Box sx={{
                display: "grid",
                gridTemplateColumns: "100px 250px 150px 100px 150px",
                borderBottom: "1px solid",
                borderBottomColor: "border.default",
                justifyContent: "space-between",
                pt: 1,
                pb: 1,
                height: 40,
                alignItems: "center"
            }}>
                <Box sx={{ fontWeight: 600 }}>
                    Ảnh
                </Box>
                <Box sx={{ fontWeight: 600 }}>
                    Họ tên
                </Box>
                <Box sx={{ fontWeight: 600 }}>
                    Mã học sinh
                </Box>
                <Box sx={{ fontWeight: 600 }}>
                    Lớp
                </Box>
                <Box sx={{ fontWeight: 600}}>
                    Điểm danh
                </Box>
            </Box >
            <Box sx={{
                overflow: "auto",
                height: `${window.innerHeight - 170}px`
            }}>
                {filteredData.map(data => {
                    return (
                        <LiveCheckInHocSinh data={data} key={data.key} />
                    );
                })}
            </Box>
        </Box>
    );
};

export default LiveCheckInHocSinhList;